import { Classes } from "@blueprintjs/core";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import styles from "./DeviceStep.module.scss";

/** Доступ к приложению отключён администратором - вместо формы входа */
export const AccessBlockedStep = ({ onBack }: { onBack: () => void }) => (
    <>
        <div className={Classes.DIALOG_BODY}>
            <div className={styles.title}>Доступ к приложению отключён</div>
            <div className={styles.text}>Обратитесь к администратору.</div>
        </div>
        <div className={`${Classes.DIALOG_FOOTER} ${styles.footer}`}>
            <PlanrButton type="blueish" size="small" onClick={onBack} style={{ width: "100%" }}>
                На страницу входа
            </PlanrButton>
        </div>
    </>
);
